
namespace GeniuzPOS.QRreport {

    @Serenity.Decorators.registerClass()
    export class QHourTimeDialog extends Serenity.EntityDialog<QHourTimeRow, any> {
        protected getFormKey() { return QHourTimeForm.formKey; }
        protected getIdProperty() { return QHourTimeRow.idProperty; }
        protected getLocalTextPrefix() { return QHourTimeRow.localTextPrefix; }
        protected getNameProperty() { return QHourTimeRow.nameProperty; }
        protected getService() { return QHourTimeService.baseUrl; }
        protected getDeletePermission() { return QHourTimeRow.deletePermission; }
        protected getInsertPermission() { return QHourTimeRow.insertPermission; }
        protected getUpdatePermission() { return QHourTimeRow.updatePermission; }

        protected form = new QHourTimeForm(this.idPrefix);

    }
}